// extracted by mini-css-extract-plugin
module.exports = {"container":"_2oH8HIiRhEYw4Qm-NqhHeq","heading":"_1sZEPqoSxRXC03iVOWgU3b","requiredLabel":"_3tRa6ia6TIzbPeT0hj1Q58","items":"_3qGV2lLwF4sQ0k_497IQNl"};